import React from 'react';

const VARIANTS = {
  default:
    'bg-white border border-gray-200 rounded-ds-lg shadow-ds-sm transition-shadow duration-200 hover:shadow-ds-md',
  elevated: 'bg-white border border-gray-200 rounded-ds-lg shadow-ds-md transition-shadow duration-200 hover:shadow-ds-lg',
  tinted: 'bg-gray-50 border border-gray-200 rounded-ds-lg shadow-ds-sm transition-shadow duration-200 hover:shadow-ds-md',
  'bordered-rose':
    'bg-white border border-gray-200 border-l-[3px] border-l-ds-rose rounded-ds-lg shadow-ds-sm transition-shadow duration-200 hover:shadow-ds-md',
  'bordered-amber':
    'bg-white border border-gray-200 border-l-[3px] border-l-ds-amber rounded-ds-lg shadow-ds-sm transition-shadow duration-200 hover:shadow-ds-md',
  'bordered-green':
    'bg-white border border-gray-200 border-l-[3px] border-l-ds-green rounded-ds-lg shadow-ds-sm transition-shadow duration-200 hover:shadow-ds-md',
};

const PADDING = {
  compact: 'p-ds-4',
  default: 'p-ds-6',
  loose: 'p-ds-8',
};

const Card = ({
  variant = 'default',
  padding = 'default',
  header,
  footer,
  className = '',
  children,
}) => {
  const shell = `${VARIANTS[variant] || VARIANTS.default} ${PADDING[padding] || PADDING.default}`;
  return (
    <section
      className={`${shell} ${className}`.trim()}
      style={{ transitionTimingFunction: 'cubic-bezier(0.22, 1, 0.36, 1)' }}
    >
      {header ? <header className="mb-ds-4 border-b border-gray-200 pb-ds-3">{header}</header> : null}
      <div className="">{children}</div>
      {footer ? <footer className="mt-ds-4 border-t border-gray-200 pt-ds-3">{footer}</footer> : null}
    </section>
  );
};

export default Card;
